import React, { useState } from "react";
import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";
import { pxToRem } from "../../../utils/styles/size";
import { SpaceCircle } from "./SpaceCircle";
import { createPortal } from "react-dom";
import FilterProjectReorderDragLayer from "../FilterProjectReorderDragLayer";
import { useDragAndDrop } from "../../../hooks/useDragAndDrop";
import { SpaceType } from "../../../types/space";
import { HandleSpaceReorderType } from "./SpacesSection";
import clsx from "clsx";

interface NoSpaceFilterItemProps {
  data: SpaceType;
  index: number;
  isSelected: boolean;
  onClickSpaceCircle: (e: React.MouseEvent) => void;
  onReorder: HandleSpaceReorderType;
}

export const NoSpaceFilterItem: React.FC<NoSpaceFilterItemProps> = ({
  index,
  data,
  isSelected,
  onClickSpaceCircle,
  onReorder,
}) => {
  const [prevIndex, setPrevIndex] = useState(index);
  const { color } = data;
  const { ref, shouldShowPreview } = useDragAndDrop({
    index,
    data,
    onReorder,
    prevIndex,
    setPrevIndex,
  });

  return (
    <Box
      borderRadius={shouldShowPreview ? "6px" : "initial"}
      bg={shouldShowPreview ? "rgba(255, 255, 255, 0.04)" : "initial"}
      w={"full"}
    >
      <Flex
        role="group"
        ref={ref}
        opacity={shouldShowPreview ? 0 : 1}
        justifyContent={"center"}
        alignItems={"center"}
        cursor={"pointer"}
        py={pxToRem(4)}
        px={pxToRem(2)}
        className={clsx(
          "rounded-[5px] border border-solid transition-colors duration-200",
          "border-transparent bg-transparent",
          "@[220px]/sidebar:hover:bg-[rgba(255,255,255,0.08)]"
        )}
      >
        <div
          className={clsx(
            "flex w-full rounded-[50%] hover:bg-[rgba(255,255,255,0.08)]",
            "@[220px]/sidebar:hover:bg-transparent"
          )}
          onClick={onClickSpaceCircle}
        >
          {/* 사이드바가 열러있을 떄(220px 이상일 때)만 보임 */}
          <div className="hidden @[220px]/sidebar:block @[220px]/sidebar:flex @[220px]/sidebar:items-center">
            <SpaceCircle
              spaceColor={color}
              isSelected={isSelected}
            />

            <Text
              textStyle={"body1"}
              color={"#D9D9D9"}
              noOfLines={1}
              ml={2}
            >
              No Space
            </Text>
          </div>

          {/* 사이드바가 닫혀있을 때(220px 미만일 때)만 보임 */}
          <div className="block @[220px]/sidebar:hidden">
            <Tooltip
              label={"No Space"}
              placement={"right"}
              closeOnScroll={true}
            >
              <SpaceCircle
                spaceColor={color}
                isSelected={isSelected}
              />
            </Tooltip>
          </div>
        </div>
      </Flex>
      {shouldShowPreview &&
        createPortal(
          <div style={{ cursor: "pointer" }}>
            <FilterProjectReorderDragLayer />
          </div>,
          document.body
        )}
    </Box>
  );
};
